<template>
  <EntityList
    :config="config"
    :columns="columns"
    single-edit
    :filter-vals.sync="filterVals"
    :filters="filters"
    :formatted-columns="formattedColumns"
    authority="General_Sponsor"
    desc-sort
  />
</template>

<script>
import EntityList from '@/layouts/entity/EntityList.vue'
import storeModule from '../SponsorStoreModule'

export default {
  components: {
    EntityList,
  },
  data() {
    return {
      filterVals: [],
      countryOptions: [],
    }
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'sponsors',
        endpoint: 'sponsors',
        route: 'sponsors',
        title: {
          single: this.$t('Sponsor Add'),
          plural: this.$t('Sponsors'),
        },
      }
    },

    columns() {
      return [
        { key: 'id', label: this.$t('id'), sortable: true },
        { key: 'title', label: this.$t('Title'), sortable: true },
        { key: 'city', label: this.$t('city'), sortable: false },
        { key: 'businessSegment', label: this.$t('Business Segment'), sortable: false },
        { key: 'phone1', label: this.$t('telephone'), sortable: false },
        { key: 'actions', label: this.$t('actions') },
      ]
    },

    formattedColumns() {
      return [
        { key: 'createdfrom', type: 'date' },
        { key: 'createdto', type: 'date' },
      ]
    },

    filters() {
      return [
        {
          name: 'country',
          label: this.$t('Country'),
          options: this.countryOptions,
        },
        {
          name: 'createdfrom',
          type: 'date',
          label: this.$t('Created From'),
          maxDateFieldIdx: '2',
        },
        {
          name: 'createdto',
          type: 'date',
          label: this.$t('Created To'),
          minDateFieldIdx: '1',
        },
        {
          name: 'enabled',
          type: 'boolean',
          label: this.$i18n.t('enabled'),
        },
      ]
    },
  },
  mounted() {
    this.$store.dispatch('app-common/fetchCountries').then(response => {
      this.countryOptions = response.data
    })
  },
}
</script>
